<template lang="pug">

    div.ui.secondary.pointing.menu

        router-link.item(:to='toIndex' exact) Anfragevarianten
        router-link.item(:to='toPrices' v-if='showPrices' exact) Preisübersicht
        router-link.item(:to='toOffers' exact) Preisangebote
        router-link.item(:to='toFiles' exact) Upload
        router-link.item(:to='toProductionCosts' v-if='showProductionCosts' exact) Produktionskosten
        span.item.disabled(v-else-if='$auth.isZmuekish') Produktionskosten
        router-link.item(:to='toAddresses' exact) Adressen
        router-link.item(:to='toQualityRating' v-if='showQualityRating' exact) Qualitätssicherung
        span.item.disabled(v-else-if='$auth.isZmuekish') Qualitätssicherung
        router-link.item(:to='toDocuments' v-if='$auth.isZmuekish' exact) Dokumente

        .right.menu
             product-action-dropdown(
                 v-bind:product-model='productModel'
                 v-bind:variant-models='variants'
             )

</template>

<script>
    import * as R from 'ramda'
    import ProductActionDropdown from '@/components/products/ProductActionDropdown'

    export default {

        components: { ProductActionDropdown },

        computed: {

            variants() {
                const productId = Number(this.$route.params.id)
                return this.$store.getters['variants/allByProductId'](productId)
            },

            showPrices() {
                return this.$auth.isZmuekish
            },

            showProductionCosts() {
                if (!this.$auth.isZmuekish) {
                    return false
                }

                const requiredStatus = ['OFFER_CONFIRMED', 'IN_PRINT', 'PRODUCTION_RELEASE', 'IN_PRODUCTION', 'DELIVERED', 'QA', 'COMPLETED' ]
                const status = this.productModel.status
                return R.contains(status, requiredStatus)
            },

            showQualityRating() {
                if (!this.$auth.isZmuekish) {
                    return false
                }

                const requiredStatus = ['QA', 'COMPLETED']
                return R.contains(this.productModel.status, requiredStatus)
            },

            toAddresses() {
                return {
                    name: 'productAddresses',
                    params: {
                        variantId: this.$route.params.variantId
                    }
                }
            },

            toQualityRating() {
                return {
                    name: 'quality-rating',
                    params: {
                        id: this.$route.params.id,
                        variantId: this.$route.params.variantId
                    }
                }
            },

            toFiles() {
                return {
                    name: 'files',
                    params: {
                        variantId: this.$route.params.variantId
                    }
                }
            },

            toIndex() {
                return {
                    name: 'products/view',
                    params: {
                        id: this.$route.params.id,
                        variantId: this.$route.params.variantId
                    }
                }
            },

            toOffers() {
                return {
                    name: 'offers',
                    params: {
                        variantId: this.$route.params.variantId
                    }
                }
            },

            toPrices() {
                return {
                    name: 'prices',
                    params: {
                        variantId: this.$route.params.variantId
                    }
                }
            },

            toProductionCosts() {
                return {
                    name: 'production-costs',
                    params: {
                        variantId: this.$route.params.variantId
                    }
                }
            },

            toDocuments() {
                return {
                    name: 'documents',
                    params: {
                        id: this.$route.params.id,
                        variantId: this.$route.params.variantId
                    }
                }
            },

        },

        props: {

            productModel: {
                type: Object,
                required: true,
            }

        }

    }

</script>

<style>
    .ui.secondary.pointing.menu .right.menu .ui.dropdown .menu > .item {
        text-align: left;
        width: 100%;
    }
</style>